import React, { useEffect, useState } from "react";
import ProductDetailBuyBox from "./ProductDetailBuyBox";
import ProductDetailAd from "./ProductDetailAd";
import store from "../../../storeWire";
import { system_notification } from "../../../store/slice/system";
import Helper from "../../../support/Helper";
import RefreshStockButton from "../../ProductListing/RefreshStockButton";
import { Tooltip } from "../../../component/Tooltip";
import $ from "jquery";
import { useQuoteDetailStore } from "src/hooks/quote-detail";
import System from "src/helper/system";
import newImg from "src/assets/images/new.png";
import farnell from "src/assets/images/farnell.png";
import Constants from "src/support/Constants";
import { useProductStore } from "src/hooks/product";

const ProductDetailRightContent = (props) => {
    const [{ productDetail }] = useProductStore();
    const [{ }, { get_approved_quote_list }, { }] = useQuoteDetailStore();

    const [parentClass, setParentClass] = useState('');
    const userType = System.avUserInfoData.userType;

    const renderTooltip = () => (
        <>
            <RefreshStockButton />
            <br />
            Refresh the product availability to a real time call
        </>
    );

    useEffect(() => {
        if (userType === Constants.siteUser.CORE) {
            async function fetchHere() {
                let reqObj = {
                    "quoteNumber": "",
                    "quoteReasonType": "",
                    "quoteSubmissionDateFrom": "",
                    "quoteSubmissionDateTo": "",
                    "quoteExpirationDateFrom": "",
                    "quoteExpirationDateTo": "",
                    "manufacturer": "",
                    "manufacturerPartNumber": productDetail?.value?.ERPMFRPartNumber,
                    "customerPartNumber": "",
                    "quoteStatus": "A", // Approved Quotes
                    "buyer": "",
                    "pageNumber": 1,
                    "pageSize": 20,
                    "sortBy": "quotelinenumber",
                    "sortType": "ASC"
                }
                await get_approved_quote_list(reqObj);
            }
            if (productDetail?.value) {
                fetchHere();
            }
        }
    }, [])

    const showFarnellInventory = (ERPPartNumber) => {
        System.popup('FarnellInventoryStockPopup', {
            ERPPartNumber: ERPPartNumber
        })
    }

    return (
        <>
            <div className="col-xl-4 col-lg-5 mt-3 mt-lg-0 pdp-container-right">
                <div className='product-detail-right mobilehide desktopshow' style={{ top: $(".header").height() }}>

                    <div className="icon-list icon-list-inline justify-content-around text-13 d-none d-sm-flex">
                        <Tooltip
                            opener={() => (
                                <a className="icon-list-item text-black" style={{ cursor: 'auto' }}>
                                    <i className="fa fa-info-circle" />
                                    <span className="text-blue text-nowrap">Tool Tip</span>
                                </a>
                            )}
                            content={() => (
                                renderTooltip()
                            )}
                        />
                        <a key={Helper.UUID()} onClick={() => { window.print() }} className="icon-list-item text-black">
                            <i className="fa fa-print" />
                            <span className="text-blue">Print</span>
                        </a>
                        <a key={Helper.UUID()} style={{ cursor: 'pointer' }}
                            className="icon-list-item text-black"
                            onClick={() => {
                                store.dispatch(system_notification({
                                    name: 'SendEmailOfReportError',
                                    data: { isPDP: true }
                                }));
                            }} >
                            <i className="fa fa-unlink" />
                            <span className="text-blue">Report Error</span>
                        </a>
                    </div>

                    <div className={parentClass} id="stock-box-pdp">
                        <ProductDetailBuyBox setParentClass={setParentClass} fetch_stock_alert_products_details={props.fetch_stock_alert_products_details}/>
                    </div>

                    {productDetail.value?.FarnellInventorySharing &&
                        <div className='farnell-box p-3'>
                            <div className='bs5 row'>
                                <label className="d-flex align-items-center ms-2">Buy from <b className='ms-1'> Farnell, </b>&nbsp;an Avnet company <Tooltip
                                    position={'top center'}
                                    opener={() => (
                                        <a className="icon-list-item text-black ms-1" style={{ cursor: 'auto' }}>
                                            <i className="fa fa-info-circle" />
                                        </a>
                                    )}
                                    content={() => (
                                        <>
                                            <div>
                                                Farnell, an Avnet company offers a wide range of products to meet your needs.
                                            </div>
                                        </>
                                    )}
                                /> </label>
                                <br />
                                <div className='col-md-8'>
                                    <a href={void (0)} className="d-flex align-items-center mt-2 text-blue cursor-pointer" onClick={() => showFarnellInventory(productDetail.value?.ERPPartNumber)}> <img src={newImg} />
                                        <span className="text-ports ms-2">View Stock from Farnell</span>
                                    </a>
                                </div>
                                <div className='col-md-4 text-right'>
                                    <img src={farnell} className='img-fluid cursor-pointer' onClick={() => showFarnellInventory(productDetail.value?.ERPPartNumber)} />
                                </div>
                            </div>
                        </div>
                    }

                </div>
                <div className='mobileads mt-3'>
                    <ProductDetailAd />
                </div>
            </div>
        </>
    );
}

export default ProductDetailRightContent;